import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../assets/images/trackerlogo.jpg"
import { useDispatch, useSelector } from "react-redux";
import { PageProps } from "../interfaces/index.types";
import { setPageContext } from "store/pageContext";
  
const Sidebar = (props: PageProps) => {
    const { page } = props;
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const roles:any = useSelector((state: any) => state.roles.value)
    const [isActive, setIsActive] = useState(true)
    
    const sidebarItems = [      
        // SUPPLIER  
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "Supplier",
            path: "supplier/dashboard"
            
        },      
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "Supplier",
            path: "supplier/purchaseorders"
            
        }, 
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "Supplier",
            path: "supplier/materialreadinessdocuments"
            
        },
        {
            title: "Proof Of Collection",
            icon: "inventory",
            role: "Supplier",
            path: "supplier/proofofcollection"
            
        },


        // CAndP  
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "CAndP",
            path: "candp/dashboard",
        },     
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "CAndP",
            path: "candp/purchaseorders",
        },
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "CAndP",
            path: "candp/materialreadinessdocument"
        },
        {
            title: "Proof Of Collection",
            icon: "inventory",
            role: "CAndP",
            path: "candp/proofofcollection"
            
        }, 
        {
            title: "User Management",
            icon: "group",
            role: "CAndP",
            path: "candp/usermanagement"
            
        },


        // TRANSIT OFFICER
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "TransitOfficer",
            path: "transitofficer/dashboard",            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "TransitOfficer",
            path: "transitofficer/purchaseorders"
        },  
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "TransitOfficer",
            path: "transitofficer/materialreadinessdocument"
            
        },        
        {
            title: "FF Assignment",
            icon: "delivery_truck_speed",
            role: "TransitOfficer",
            path: "transitofficer/freightforwarders"
            
        },        
        {
            title: "Proof Of Collection",
            icon: "inventory",
            role: "TransitOfficer",
            path: "transitofficer/proofofcollection"
            
        },
        {
            title: "Shipping Documents",
            icon: "home_storage",
            role: "TransitOfficer",
            path: "transitofficer/shippingdocuments"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "TransitOfficer",
            path: "transitofficer/modeoftransportationchange"
            
        },
        {
            title: "Shipping Address Mapper",
            icon: "map_search",
            role: "TransitOfficer",
            path: "transitofficer/shippingaddressmapper"
            
        }, 
        {
            title: "Freight Cost Settings",
            icon: "settings",
            role: "TransitOfficer",
            path: "transitofficer/modeoftransportation/thresholdsettings"
            
        }, 

        // HEAD OF TRANSIT
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "HeadOfTransit",
            path: "headoftransit/dashboard",            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "HeadOfTransit",
            path: "headoftransit/purchaseorders"
        },  
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "HeadOfTransit",
            path: "headoftransit/materialreadinessdocument"
            
        },        
        {
            title: "FF Assignment",
            icon: "delivery_truck_speed",
            role: "HeadOfTransit",
            path: "headoftransit/freightforwarders"
            
        },        
        {
            title: "Proof Of Collection",
            icon: "inventory",
            role: "HeadOfTransit",
            path: "headoftransit/proofofcollection"
            
        },
        {
            title: "Shipping Documents",
            icon: "home_storage",
            role: "HeadOfTransit",
            path: "headoftransit/shippingdocuments"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "HeadOfTransit",
            path: "headoftransit/modeoftransportationchange"
            
        },
        {
            title: "User Management",
            icon: "group",
            role: "HeadOfTransit",
            path: "headoftransit/usermanagement"
            
        },
        {
            title: "Shipping Address Mapper",
            icon: "map_search",
            role: "HeadOfTransit",
            path: "headoftransit/shippingaddressmapper"
            
        }, 
        {
            title: "Freight Cost Settings",
            icon: "settings",
            role: "HeadOfTransit",
            path: "headoftransit/modeoftransportation/thresholdsettings"
            
        }, 

        // SHIPPING OFFICER
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "ShippingOfficer",
            path: "shippingofficer/dashboard",            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "ShippingOfficer",
            path: "shippingofficer/purchaseorders"
        },  
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "ShippingOfficer",
            path: "shippingofficer/materialreadinessdocument"
            
        },        
        {
            title: "FF Assignment",
            icon: "delivery_truck_speed",
            role: "ShippingOfficer",
            path: "shippingofficer/freightforwarders"
            
        },        
        {
            title: "Proof Of Collection",
            icon: "inventory",
            role: "ShippingOfficer",
            path: "shippingofficer/proofofcollection"
            
        },
        {
            title: "Shipping Documents",
            icon: "home_storage",
            role: "ShippingOfficer",
            path: "shippingofficer/shippingdocuments"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "ShippingOfficer",
            path: "shippingofficer/modeoftransportationchange"
            
        },
        {
            title: "Shipping Address Mapper",
            icon: "map_search",
            role: "ShippingOfficer",
            path: "shippingofficer/shippingaddressmapper"
            
        }, 
        {
            title: "Freight Cost Settings",
            icon: "settings",
            role: "ShippingOfficer",
            path: "shippingofficer/modeoftransportation/thresholdsettings"
            
        }, 
        

        // FreightForwarder
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "FreightForwarder",
            path: "freightforwarder/dashboard"
            
        }, 
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "FreightForwarder",
            path: "freightforwarder/materialreadinessdocument"
            
        },
        {
            title: "Purchase Orders",
            icon: "list_alt",
            role: "FreightForwarder",
            path: "freightforwarder/purchaseorders"
            
        }, 
        {
            title: "Report",
            icon: "data_table",
            role: "FreightForwarder",
            path: "freightforwarder/report"
            
        }, 
        {
            title: "Proof Of Collection",
            icon: "inventory",
            role: "FreightForwarder",
            path: "freightforwarder/proofofcollection"
            
        },
        {
            title: "Consolidated Documents",
            icon: "view_list",
            role: "FreightForwarder",
            path: "freightforwarder/consolidateddocuments"
            
        },
        {
            title: "Shipping Documents",
            icon: "home_storage",
            role: "FreightForwarder",
            path: "freightforwarder/shippingdocuments"
            
        },

        // EntityRepresentative
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "EntityRepresentative",
            path: "entityrepresentative/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "EntityRepresentative",
            path: "entityrepresentative/purchaseorders"
            
        },
        {
            title: "Review Material Attachments",
            icon: "person_check",
            role: "EntityRepresentative",
            path: "entityrepresentative/reviewmaterialattachments"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "EntityRepresentative",
            path: "entityrepresentative/modeoftransportationchange"
            
        },

        // EntityRepManager
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "EntityRepManager",
            path: "entityrepmanager/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "EntityRepManager",
            path: "entityrepmanager/purchaseorders"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "EntityRepManager",
            path: "entityrepmanager/modeoftransportationchange"
            
        },

        // EntityRepGenManager
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "EntityRepGenManager",
            path: "entityrepgenmanager/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "EntityRepGenManager",
            path: "entityrepgenmanager/purchaseorders"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "EntityRepGenManager",
            path: "entityrepgenmanager/modeoftransportationchange"
            
        },

        // TransitManager
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "TransitManager",
            path: "transitmanager/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "TransitManager",
            path: "transitmanager/purchaseorders"
            
        },
        {
            title: "Material Readiness Documents",
            icon: "note_stack",
            role: "TransitManager",
            path: "transitmanager/materialreadinessdocument"
            
        },
        {
            title: "LCA Assignment",
            icon: "location_home",
            role: "TransitManager",
            path: "transitmanager/batch-assign-shipping-documents"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "TransitManager",
            path: "transitmanager/modeoftransportationchange"
            
        },
        {
            title: "User Management",
            icon: "group",
            role: "TransitManager",
            path: "transitmanager/usermanagement"
            
        },

        // DGM TLOGISTICS
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "DGMTechnicalLogistics",
            path: "dgmtechnicallogistics/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "DGMTechnicalLogistics",
            path: "dgmtechnicallogistics/purchaseorders"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "DGMTechnicalLogistics",
            path: "dgmtechnicallogistics/modeoftransportationchange"
            
        },

        // GM TECHLOG
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "GMTechnicalLogistics",
            path: "gmtechnicallogistics/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "GMTechnicalLogistics",
            path: "gmtechnicallogistics/purchaseorders"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "GMTechnicalLogistics",
            path: "gmtechnicallogistics/modeoftransportationchange"
            
        },

        // ED TECHNCIAL DIRECTORATE
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "EDTechnicalDirectorate",
            path: "edtechnicaldirectorate/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "distance",
            role: "EDTechnicalDirectorate",
            path: "edtechnicaldirectorate/purchaseorders"
            
        },
        {
            title: "Mode Of Transportation Change",
            icon: "airplanemode_active",
            role: "EDTechnicalDirectorate",
            path: "edtechnicaldirectorate/modeoftransportationchange"
            
        },


        // LocalClearingAgent
        {
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "LocalClearingAgent",
            path: "localclearingagent/dashboard"
            
        },
        {
            title: "Shipping Documents",
            icon: "home_storage",
            role: "LocalClearingAgent",
            path: "localclearingagent/shippingdocuments"
            
        },


        // PORT OFFICER
        {   
            title: "Dashboard Analytics",
            icon: "insert_chart",
            role: "PortOfficer",
            path: "portofficer/dashboard"
            
        },
        {
            title: "Purchase Orders Tracking",
            icon: "list_alt",
            role: "PortOfficer",
            path: "portofficer/purchaseorders"
            
        }, 
        {
            title: "Shipping Documents",
            icon: "home_storage",
            role: "PortOfficer",
            path: "portofficer/shippingdocuments"
            
        },
    ];

    return (
        <div id="thenavbar" className={isActive ? "sidenav active" : "sidenav"}>
            <div className="menu_btn" onClick={() => setIsActive(!isActive)}>
                <span className="material-symbols-rounded">menu</span>
            </div>
            <img style={{marginTop: "12px"}} width="80px" src={logo} alt="" />
            <ul>
                {sidebarItems.map((item, index) => {
                    // const roleColor = TRTRoles.find(role => item.role === role.role)?.color || "#F5F5F5"; // Default to white if no color found
                    return (
                        roles?.includes(item.role) && (item.role.toLocaleLowerCase() === window.location.pathname.split("/")[1].toLocaleLowerCase()) && (
                            <div>
                                {/* display group name*/}
                                {/* {item.group && roles.length > 1 && <p className="fw-600 mt-2 f-10" style={{textAlign: "left", margin: "8px", color: "#e38600"}}>{item.group?.toLocaleUpperCase()}</p>} */}

                                <li
                                    key={index}
                                    className={page === item.title && (item.path.split("/")[0] === window.location.pathname.split("/")[1]) ? "nav-item active" : "nav-item"}
                                    // style={roles.length > 1 ? { backgroundColor: roleColor } : {}}
                                    style={{border: "1px solid #e5e5e5"}}
                                    onClick={() => {
                                        navigate("/" + item.path);
                                        dispatch(setPageContext({}));
                                    }}
                                >                               
                                    <span className="material-symbols-rounded">{item.icon}</span>
                                    <p>{item.title}</p>
                                </li>
                            </div>
                        )
                    );
                })}
            </ul>            
        </div>
    );
} 

export default Sidebar